import React from "react";
import { Login, Head } from "../components";

const LoginPage = () => (
  <>
    <Head title="Expense Tracker | Login" />
    <Login />
  </>
);

export default LoginPage;
